/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ format: NonNullable<unknown> }} Tfield_League_Format_MismatchInputs */



/**
* | output |
* | --- |
* | "requires {format}" |
*
* @param {Tfield_League_Format_MismatchInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_league_format_mismatch = /** @type {((inputs: Tfield_League_Format_MismatchInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_League_Format_MismatchInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`nécessite ${i?.format}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`requiere ${i?.format}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`requer ${i?.format}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`richiede ${i?.format}`)
	return /** @type {LocalizedString} */ (`requires ${i?.format}`)
});